import React, { FC } from 'react'

import { PhoneIcon, TvIcon, WifiIcon } from '~/assets/icons'
import generateProviderImage from '~/components/deal/utils/provider-image'
import generateIcons, { ServiceIconType } from '~/components/deal/utils/services'
import { Deal } from '~/gql/graphql'

import styles from './styles.module.css'

interface TitleProps {
  deal: Deal
  isExtensionShown: boolean
  isMobileView: boolean
}

const Title: FC<TitleProps> = ({ deal, isExtensionShown, isMobileView }) => {
  const { title, provider, services } = deal
  const { name: providerName } = provider
  const src = generateProviderImage(providerName)
  const icons = generateIcons(services)

  const getIcon = (icon: ServiceIconType) => {
    switch (icon) {
      case 'phone':
        return <PhoneIcon />
      case 'tv':
        return <TvIcon />
      case 'wifi':
        return <WifiIcon height='100%' width='100%' color='#575761' />
    }
  }

  return (
    <div className={styles.container} data-ext-shown={isExtensionShown} data-is-mobile-view={isMobileView}>
      <img src={src} alt={providerName} className={styles.image} />

      <div className={styles.content} data-is-mobile-view={isMobileView}>
        <h3
          className={styles.title}
          data-is-mobile-view={isMobileView}
          itemProp='brand'
          itemType='https://schema.org/Brand'
          itemScope
        >
          <meta itemProp='name' content={deal.provider.name} />
          <meta itemProp='image' content={generateProviderImage(deal.provider.name)} />
          {title}
        </h3>

        {icons && (
          <div className={styles.icons}>
            {icons.map((icon) => (
              <span className={styles.icon} data-is-mobile-view={isMobileView} key={icon}>
                {getIcon(icon)}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Title
